// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import User from './User/User'
import template from './modules/template'
import information from './modules/information'
import navigation from './modules/navigation' // 导入导航模块
import seo from './modules/seo' // 导入SEO模块
import serviceNavigation from './modules/serviceNavigation'

const store = new Vuex.Store({
  modules: {
    User,
    template,
    information,
    navigation, // 注册导航模块
    seo, // 注册SEO模块
    serviceNavigation
  },
})

export default store
